import React from 'react';
import { IItemForGetShortInfo, ITotalPrice, IItemForGetShortDishInfo } from 'types';
import AdditionalDishCategorySelect from './components/AdditionalDishCategorySelect';
import AdditionalDishSubCategorySelect from './components/AdditionalDishSubCategorySelect';
import AdditionalDishMultipleSelect from './components/AdditionalDishMultipleSelect/AdditionalDishMultipleSelect';
import DnDList from './components/DnDList';
import style from './AdditionalDishesField.module.scss';

interface IAdditionalDishesField {
	setAdditionalDishes: (value: string[]) => void;
	setAdditionalDishCategory: (value: Nullable<string>) => void;
	totalPrices: ITotalPrice[];
	setAdditionalDishSubCategory: (value: Nullable<string>) => void;
	setFetchedAdditionalDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedAdditionalDishCategory: Nullable<string>;
	setFetchedAdditionalDishes: (value: IItemForGetShortInfo[]) => void;
	selectedAdditionalDishSubCategory: Nullable<string>;
	selectedAdditionalDishes: string[];
	removeAdditionalDish: (value: string) => void;
	fetchedAdditionalDishes: IItemForGetShortDishInfo[];
}

const AdditionalDishesField: React.FC<IAdditionalDishesField> = ({
	setAdditionalDishes,
	totalPrices,
	setAdditionalDishCategory,
	selectedAdditionalDishCategory,
	setAdditionalDishSubCategory,
	setFetchedAdditionalDishSubCategories,
	selectedAdditionalDishes,
	selectedAdditionalDishSubCategory,
	setFetchedAdditionalDishes,
	fetchedAdditionalDishes,
	removeAdditionalDish,
}) => {
	return (
		<div className={style.container} data-test="AdditionalDishesField">
			<div className={style.newAdditionalDishFields}>
				<AdditionalDishCategorySelect
					totalPrices={totalPrices}
					setAdditionalDishCategory={setAdditionalDishCategory}
				/>
				<AdditionalDishSubCategorySelect
					selectedAdditionalDishCategory={selectedAdditionalDishCategory}
					setAdditionalDishSubCategory={setAdditionalDishSubCategory}
					setFetchedAdditionalDishSubCategories={setFetchedAdditionalDishSubCategories}
				/>
				<AdditionalDishMultipleSelect
					selectedAdditionalDishes={selectedAdditionalDishes}
					selectedAdditionalDishSubCategory={selectedAdditionalDishSubCategory}
					setAdditionalDishes={setAdditionalDishes}
					setFetchedAdditionalDishes={setFetchedAdditionalDishes}
				/>
			</div>
			<DnDList
				selectedAdditionalDishes={selectedAdditionalDishes}
				fetchedAdditionalDishes={fetchedAdditionalDishes}
				setAdditionalDishes={setAdditionalDishes}
				removeAdditionalDish={removeAdditionalDish}
			/>
		</div>
	);
};

export default React.memo(AdditionalDishesField);
